module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "regular-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit()
      }
    }
  }, [_c('amount-field', {
    attrs: {
      "error": _vm.$attrs.errors.transaction.amount
    },
    model: {
      value: (_vm.$attrs.transaction.amount),
      callback: function($$v) {
        _vm.$set(_vm.$attrs.transaction, "amount", $$v)
      },
      expression: "$attrs.transaction.amount"
    }
  }), _vm._v(" "), _c('transaction-type-field', {
    attrs: {
      "error": _vm.$attrs.errors.transaction.transaction_type
    },
    model: {
      value: (_vm.$attrs.transaction.transaction_type),
      callback: function($$v) {
        _vm.$set(_vm.$attrs.transaction, "transaction_type", $$v)
      },
      expression: "$attrs.transaction.transaction_type"
    }
  }), _vm._v(" "), _c('date-time-field', {
    attrs: {
      "error": _vm.$attrs.errors.transaction.datetime
    },
    model: {
      value: (_vm.$attrs.transaction.datetime),
      callback: function($$v) {
        _vm.$set(_vm.$attrs.transaction, "datetime", $$v)
      },
      expression: "$attrs.transaction.datetime"
    }
  }), _vm._v(" "), _c('notation-field', {
    attrs: {
      "error": _vm.$attrs.errors.transaction.notation
    },
    model: {
      value: (_vm.$attrs.transaction.notation),
      callback: function($$v) {
        _vm.$set(_vm.$attrs.transaction, "notation", $$v)
      },
      expression: "$attrs.transaction.notation"
    }
  }), _vm._v(" "), _c('client-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!(_vm.$attrs.transaction.client)),
      expression: "!($attrs.transaction.client)"
    }],
    attrs: {
      "error": _vm.$attrs.errors.transaction.client
    },
    model: {
      value: (_vm.$attrs.transaction.client),
      callback: function($$v) {
        _vm.$set(_vm.$attrs.transaction, "client", $$v)
      },
      expression: "$attrs.transaction.client"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": _vm.submitLabel
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d9148ad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/transaction/TransactionBlankForm.vue
// module id = 669
// module chunks = 0